import * as Api from '@ViewModels';
import { useQuery } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { ImpersonationBroker, ITemplateCard } from '../../viewmodels/AppViewModels';
import { LevStandardQueryMeta, reactQueryClient } from '../../web/ReactQueryProvider';

export const EMAIL_ALL_CATEGORY_TEMPLATES_QUERY_KEY = 'emailAllCategoryTemplates';

export const useEmailAllCategoryTemplates = ({
	industry,
	excludeExpired = true,
	enabled = true,
	impersonationContext,
	meta,
}: {
	industry: Api.Industry;
	enabled?: boolean;
	excludeExpired?: boolean;
	impersonationContext?: Api.IImpersonationContext;
	meta?: LevStandardQueryMeta;
}) => {
	const userSession = useUserSession();
	return useQuery({
		enabled,
		queryFn: () => {
			return userSession.webServiceHelper.callAsync<Api.IDictionary<ITemplateCard[]>>(
				ImpersonationBroker.composeApiUrl({
					queryParams: {
						excludeExpired,
					},
					urlPath: `template/${encodeURIComponent(industry)}/browse`,
					impersonationContext,
				}),
				'GET'
			);
		},
		queryKey: [EMAIL_ALL_CATEGORY_TEMPLATES_QUERY_KEY, industry, excludeExpired, impersonationContext],
		meta,
	});
};

export const invalidateEmailAllCategoryTemplates = () => {
	reactQueryClient.invalidateQueries({ queryKey: [EMAIL_ALL_CATEGORY_TEMPLATES_QUERY_KEY] });
};
